// extracted by mini-css-extract-plugin
module.exports = {"doubleScroll":"top-scrollbar_doubleScroll__2X5JU","topScroll":"top-scrollbar_topScroll__2cD7W"};